import { render } from "./CardRequirementComponent.vue?vue&type=template&id=6cbe3e3c&ts=true"
import script from "./CardRequirementComponent.vue?vue&type=script&lang=ts"
export * from "./CardRequirementComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__